import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeSwitcher from './ThemeSwitcher';
import './WorkspaceFrame.css';

const WorkspaceFrame = ({ children, className = '' }) => {
  const { t } = useTranslation();
  const rootClassName = ['workspace-frame', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <header className="workspace-frame__header">
        <span className="workspace-frame__brand">{t('dashboard.title')}</span>
        <div className="workspace-frame__utilities utility-actions">
          <ThemeSwitcher />
          <LanguageSwitcher />
        </div>
      </header>
      {children}
    </div>
  );
};

export default WorkspaceFrame;
